import React from 'react';
import BaseClass from 'components/BaseClass';
import { wrapComponent } from 'utils/framework';

import userUtils from 'utils/User';
import decorators from 'utils/decorators';
import profileApi from 'services/api/profile';
import { noPreferenceOptions, notSureOptions } from 'constants/beautyPreferences';
import { WORLD_KEYS } from 'components/BeautyPreferencesWorld/constants';
import Helpers from 'utils/Helpers';

import { Text, Box } from 'components/ui';
import Radio from 'components/Inputs/Radio/Radio';
import localeUtils from 'utils/LanguageLocale';
import typography from 'style/typography';

const getText = localeUtils.getLocaleResourceFile('components/RichProfile/EditMyProfile/Content/Privacy/locales', 'Privacy');

class Privacy extends BaseClass {
    constructor(props) {
        super(props);

        this.state = {
            biPrivate: false,
            isProfilePrivate: false,
            isUserReady: false
        };
    }

    componentDidMount() {
        const { biPrivate = {} } = this.props.socialProfile || {};
        decorators
            .withInterstice(profileApi.getPublicProfileByNickname)(userUtils.getNickname())
            .then(data => {
                this.setState({
                    biPrivate: biPrivate.biPrivate || data.biPrivate,
                    isProfilePrivate: data.isPrivate,
                    isUserReady: true,
                    personalizedInformation: this.props.biAccount?.personalizedInformation || {}
                });
            });
    }

    getData = () => {
        return { biPrivate: { biPrivate: this.state.biPrivate } };
    };

    getAttributes = () => {
        const { customerPreference } = this.props;

        if (!customerPreference || Object.keys(customerPreference).length === 0) {
            return null;
        }

        const excluded = new Set([...(noPreferenceOptions || []), ...(notSureOptions || [])]);

        const allowedKeys = new Set(['skinTone', 'skinType', 'hairColor', 'eyeColor', 'colorIQ']);

        const worlds = [WORLD_KEYS.MAKEUP, WORLD_KEYS.FRAGRANCE, WORLD_KEYS.HAIR, WORLD_KEYS.SKINCARE];

        const bullets = [];
        const seenRefKeys = new Set();

        worlds.forEach(world => {
            const worldPrefs = customerPreference?.[world] || {};

            Object.entries(worldPrefs).forEach(([refKey, values]) => {
                if (!allowedKeys.has(refKey) || seenRefKeys.has(refKey)) {
                    return;
                }

                const hasValid = Array.isArray(values) && values.some(v => !excluded.has(v));

                if (hasValid) {
                    seenRefKeys.add(refKey);
                    const label = Helpers.titleCase(getText(refKey)).replace(/\bIq\b/g, 'IQ');
                    bullets.push(<li key={`attr:${refKey}`}>{label}</li>);
                }
            });
        });

        return bullets.length ? bullets : null;
    };

    handleBiPrivateTrue = () => {
        this.setState({ biPrivate: true });
    };

    handleBiPrivateFalse = () => {
        this.setState({ biPrivate: false });
    };

    render() {
        return (
            <div css={typography}>
                <Text
                    is='p'
                    marginBottom={1}
                >
                    {getText('beautyPreferencesInclude')}
                </Text>
                <ul>{this.getAttributes()}</ul>
                <Box
                    is='fieldset'
                    marginY={4}
                >
                    <Text
                        is='legend'
                        marginBottom={2}
                    >
                        {getText('beautyPreferencesVisible')}
                    </Text>
                    <Radio
                        name='privacyVisibility'
                        value='everyone'
                        checked={!this.state.biPrivate}
                        onChange={this.handleBiPrivateFalse}
                        paddingY={2}
                    >
                        {getText('everyone')}
                    </Radio>
                    <Radio
                        name='privacyVisibility'
                        value='justMe'
                        checked={this.state.biPrivate}
                        onChange={this.handleBiPrivateTrue}
                        paddingY={2}
                    >
                        {getText('justMe')}
                    </Radio>
                </Box>
                <Box
                    fontSize='sm'
                    color='gray'
                    lineHeight='tight'
                >
                    <p>{getText('yourSkincareConcerns')}</p>
                    <p>{getText('yourBeautyInsider')}</p>
                    <Text
                        is='p'
                        marginBottom={0}
                    >
                        {getText('forMoreInformation')} <a href='/privacy-policy'>{getText('privacyPolicy')}</a> {getText('and')}{' '}
                        <a href='/terms-of-use'>{getText('termsOfUse')}</a>
                    </Text>
                </Box>
            </div>
        );
    }
}

export default wrapComponent(Privacy, 'Privacy');
